<script setup>
import halls from "~/utils/halls";

const route = useRoute();

useHead({
  // Can be static or computed
  title: "РУСДРАМ",
  meta: [
    {
      hid: "title",
      property: "title",
      content: "РУСДРАМ",
    },
    {
      hid: "og:title",
      property: "og:title",
      content: "РУСДРАМ",
    },
    {
      hid: "description",
      name: "description",
      content: "Залы | Государственный русский театр драмы им. Ф. А. Искандера",
    },
    {
      hid: "og:description",
      property: "og:description",
      content: "Залы | Государственный русский театр драмы им. Ф. А. Искандера",
    },
    {
      hid: "url",
      name: "url",
      content: `https://rusdram.org${route.fullPath}`,
    },
    {
      hid: "og:url",
      property: "og:url",
      content: `https://rusdram.org${route.fullPath}`,
    },
    {
      hid: "image",
      name: "image",
      content: "https://rusdram.org/rusdram.jpg",
    },
    {
      name: "og:image",
      property: "og:image",
      content: "https://rusdram.org/rusdram.jpg",
    },
  ],
});
</script>

<template>
  <nuxt-layout name="default">
    <r-section>
      <div class="grid grid-cols-1 xl:grid-cols-3 gap-7">
        <nuxt-link
          v-for="hall in halls"
          :key="hall.type"
          :to="`/theater/halls/${hall.type}`"
        >
          <article class="h-40 rounded-lg relative flex p-7">
            <h6 class="text-white text-4xl my-auto">{{ hall.label }}</h6>
            <RAnimatedBackground />
          </article>
        </nuxt-link>
      </div>
    </r-section>
  </nuxt-layout>
</template>
